import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

const HERO_BG = "https://pub-016752fa37b9415b9be58d1981d2304f.r2.dev/images/af5c1ae4-797e-4f4b-8b32-3ee85d8432c9.jpg";

export const HeroSection = () => (
  <section className="relative h-[520px] md:h-[560px] overflow-hidden" data-testid="hero-section">
    <img src={HERO_BG} alt="Konkan coast" className="absolute inset-0 w-full h-full object-cover" loading="eager" />
    <div className="absolute inset-0 bg-gradient-to-r from-black/50 via-black/25 to-transparent" />
    <div className="relative z-10 h-full max-w-7xl mx-auto px-6 md:px-8 flex flex-col justify-center">
      <div className="max-w-xl animate-fade-up">
        <h1 className="text-4xl sm:text-5xl lg:text-[3.4rem] font-bold text-white leading-[1.15] mb-4">
          Stay Close to Nature,<br />
          <span className="text-[#B84F3E]">Live the Konkan Way</span>
        </h1>
        <p className="text-base md:text-lg text-white/85 mb-6 max-w-md leading-relaxed">
          Discover handpicked homestays across Konkan for an authentic & memorable stay.
        </p>
        <Link to="/listings" data-testid="hero-explore-btn">
          <Button className="bg-primary text-white hover:bg-primary/90 rounded-full px-7 py-5 text-sm font-semibold shadow-lg">
            Explore Homestays
          </Button>
        </Link>
      </div>
    </div>
  </section>
);
